import { getData } from '../../../get-table'
import { HttpService } from '../../../http.service'
export * from './../types'
const http = new HttpService()

export interface ParametersBanamexPaylink484 {
  payrolls: string[]
  process: string[]
  startDate: Date
  endDate: Date
  paymentDate: Date
  currency: string
  concepts: string[]
  banks: string[]
  paymentBases: string[]
  accountTypes: string[]
  paymentReference: string
  description: string
  reference1: string
  reference2: string
  reference3: string
  reference4: string
  secuence: string
  term: string
  employees: string[]
  paymentMethod: string
  reportType: string
}

export interface ReportBanamexPaylink484 {
  code: string
  parameters: ParametersBanamexPaylink484
}

export async function generateBanamexPaylink484(
  data: ReportBanamexPaylink484
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      paymentDate: data.parameters.paymentDate,
      concepts: data.parameters.concepts,
      banks: data.parameters.banks,
      currency: data.parameters.currency,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      paymentReference: data.parameters.paymentReference,
      description: data.parameters.description,
      reference1: data.parameters.reference1,
      reference2: data.parameters.reference2,
      reference3: data.parameters.reference3,
      reference4: data.parameters.reference4,
      term: data.parameters.term,
      employees: data.parameters.employees,
      paymentMethod: data.parameters.paymentMethod,
      reportType: data.parameters.reportType
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function getPaymentMethodByBank(companyId?: string) {
  const where = [
    `payment_methods.is_deleted = false AND payment_methods.company_id = '${companyId}' AND payment_methods.currency_id = '0ea64e19-642c-4974-9243-362c9a5615f6' AND payment_methods.payment_type_id = '7d5d4077-5174-4e4b-b347-f81498b2a32c'
    AND banks.id = '46e47d64-4f57-4bf1-a284-1fdcc697ae74'`
  ]
  const data = await getData<any>({
    tables: ['pg_payment_methods'],
    fields: [
      'payment_methods.id',
      "concat(banks.name, ' - ', payment_methods.custom_fields->>'custom:bankNumberClient') as name"
    ],
    join: [
      "INNER JOIN banks ON (payment_methods.custom_fields->>'custom:bank')::varchar = banks.id::varchar"
    ],
    where
  })

  return data[0].results
}

export function getTerms(paymentType: string) {
  const formatFile = new Map<string, any>([
    [
      '001',
      [
        { id:  '00', name: '00 - Mismo Día' },
      ]
    ],
    [
      '002',
      [
        { id:  '00', name: '00 - Mismo Día' },
        { id:  '24', name: '24 - 24 Horas' },
      ]
    ]
  ])

  return formatFile.get(paymentType)
}

export async function getEmployeesByAccountType(banksIds: string, employeesIds: string) {
  const where = [
    `banks.id IN (${banksIds})`,
    `employees.id IN (${employeesIds})`,
    'employee_accounts.is_active_account=true'
  ]

  // if ( accountType && accountType == '002' ) {
  //   const accountTypeId = "'76c6abd2-e6a3-420f-8c2d-fe4769e998b1', '9d7710f9-15b3-46fb-90b9-7fb997880203'"
  //   where.push(`employee_accounts.account_type_id in (${accountTypeId})`)
  // }

  const data = await getData<any>({
    tables: ['pg_employee_accounts'],
    fields: [
      'employees.id',
      'employees.name',
      'directions.name as direccion',
      'managements.name as gerencia',
      'departments.name as departamento',
      'sucursals.name as sucursal',
      'positions.name as cargo',
      'turns.name as turno',
      'employees.leave_date as fechaSalida',
      'employees.code as codigo',
      'joining_reasons.name as causaIngreso',
      "CONCAT(employees.code,' - ',employees.name) as codigo_name",
      "STRING_AGG(banks.id::text, ', ') as bankId",
      'false as isChecked'
    ],
    join: [
      'INNER JOIN employees ON employee_accounts.employee_id = employees.id',
      'INNER JOIN banks ON employee_accounts.bank_id = banks.id',
      'LEFT JOIN directions ON employees.direction_id = directions.id',
      'LEFT JOIN managements ON employees.management_id = managements.id',
      'LEFT JOIN departments ON employees.department_id = departments.id',
      'LEFT JOIN sucursals ON employees.sucursal_id = sucursals.id',
      'LEFT JOIN positions ON employees.position_id = positions.id',
      'LEFT JOIN turns ON employees.turn_id = turns.id',
      'LEFT JOIN joining_reasons ON employees.joining_reason_id = joining_reasons.id'
    ],
    where,
    modifier: [
      'group by employees.id,employees.name, employees.leave_date, employees.code,directions.name,managements.name,sucursals.name,departments.name,positions.name,turns.name,joining_reasons.name',
      'order by employees.name asc'
    ]
  })

  return data[0].results
}

export async function getLoans(
  payrollIds: string,
  endDate: string,
  loanTypes: string,
  employees: string,
  startDate?: string,
) {
  const data = await getData<any>(
    {
      tables: ['pg_loans'],
      fields: [
        'loans.id as id',
        'loans.employee_id as employeeId',
        'loans.amount',
        'loans.currency_id as currencyId',
        'loans.concept_id as conceptId',
        'loans.quota_amount as quotaAmount',
        'loans.start_date as startDate',
        'loans.end_date as endDate',
        'loans.is_loan_paid as isLoanPaid',
        'loans.is_inactive as isInactive',
        'loans.loan_type_id as loanTypeId',
        'loans.balance as balance',
        'loan_types.code as codeLoanType'
      ],
      where: [
        `loans.payroll_id IN (${payrollIds})`,
        `loans.employee_id IN (${employees})`,
        `loans.start_date <= '${endDate}'`,
        `loans.is_inactive = false`,
        `employees.leave_date is null`,
        `loans.loan_type_id IN (${loanTypes})`
      ],
      join: [
        'INNER JOIN employees ON employees.id = loans.employee_id',
        'INNER JOIN loan_types ON loan_types.id = loans.loan_type_id'
      ]
    },
  )

  let _employees: any = []
  for (const loans of data[0].results) {
    _employees.push(loans.employeeId)
  }
  return _employees
}

export async function getLoansTypes(codes: any = '') {
  const where = ['is_deleted = false']
  if (codes !== '') where.push(`code IN (${codes})`)
  const data = await getData<any>({
    tables: ['pg_loan_types'],
    fields: ['id'],
    where,
    modifier: ['order by name asc']
  })

  return data[0].results
}

export async function getEmployeesLoans(employeesIds: string) {
  const where = [
    `employees.id IN (${employeesIds})`,
    'employee_accounts.is_active_account=true'
  ]

  const data = await getData<any>({
    tables: ['pg_employee_accounts'],
    fields: [
      'employees.id',
      'employees.name',
      'directions.name as direccion',
      'managements.name as gerencia',
      'departments.name as departamento',
      'sucursals.name as sucursal',
      'positions.name as cargo',
      'turns.name as turno',
      'employees.leave_date as fechaSalida',
      'employees.code as codigo',
      'joining_reasons.name as causaIngreso',
      "CONCAT(employees.code,' - ',employees.name) as codigo_name",
      "STRING_AGG(banks.id::text, ', ') as bankId",
      'false as isChecked'
    ],
    join: [
      'INNER JOIN employees ON employee_accounts.employee_id = employees.id',
      'INNER JOIN banks ON employee_accounts.bank_id = banks.id',
      'LEFT JOIN directions ON employees.direction_id = directions.id',
      'LEFT JOIN managements ON employees.management_id = managements.id',
      'LEFT JOIN departments ON employees.department_id = departments.id',
      'LEFT JOIN sucursals ON employees.sucursal_id = sucursals.id',
      'LEFT JOIN positions ON employees.position_id = positions.id',
      'LEFT JOIN turns ON employees.turn_id = turns.id',
      'LEFT JOIN joining_reasons ON employees.joining_reason_id = joining_reasons.id'
    ],
    where,
    modifier: [
      'group by employees.id,employees.name, employees.leave_date, employees.code,directions.name,managements.name,sucursals.name,departments.name,positions.name,turns.name,joining_reasons.name',
      'order by employees.name asc'
    ]
  })

  return data[0].results
}

export function reduceEmployees(employees: Array<[]>) {
  let uniqueEmployees: any = []
  employees.reduce((res: any, value: any) => {
    if (!res[value]) {
      res[value] = value
      uniqueEmployees.push(value)
    }
    return res
  }, {})

  return uniqueEmployees
}